/**
 * "Book your job now" from the customer's report — the customer confirms their details and asks
 * the office to call them to schedule.
 *
 *   in the app → their follow-up moves to Calls › Call Now with the request in Notes
 *   to Zoho    → queued as report.bookingRequest (server: a call task for the office on the Deal,
 *                with the chosen package, contact details, best time and note)
 */
import { queueChange } from './sync';
import { requestCallBack } from './followUps';

export const BEST_TIMES = ['Morning', 'Afternoon', 'Evening'];

export const requestBooking = async ({ leadId, name, phone, email, address, bestTime, note, quote }) => {
  const clean = (v) => (v || '').trim();
  if (!clean(name)) throw new Error('Please add your name.');
  if (String(phone || '').replace(/\D/g, '').length < 10) throw new Error('Please add a phone number we can call.');

  const summary = [
    `Wants to book: ${quote ? `${quote.name} (${quote.total})` : 'a package'}.`,
    bestTime ? `Best time to call: ${bestTime}.` : '',
    `Phone: ${clean(phone)}${clean(email) ? ` · Email: ${clean(email)}` : ''}.`,
    clean(note) ? `Note: ${clean(note)}` : '',
  ]
    .filter(Boolean)
    .join(' ');

  requestCallBack({ leadId, name: clean(name), address: clean(address), text: summary, quoteName: quote && quote.name });
  queueChange({
    type: 'report.bookingRequest',
    leadId: leadId || null,
    label: `${clean(name)} — asked to book${quote ? ` ${quote.name}` : ''}`,
    payload: { name: clean(name), phone: clean(phone), email: clean(email), address: clean(address), bestTime, note: clean(note), quote },
  });
  return { ok: true };
};
